import { render, staticRenderFns } from "./position.vue?vue&type=template&id=786b6110&scoped=true&"
import script from "./position.vue?vue&type=script&lang=js&"
export * from "./position.vue?vue&type=script&lang=js&"
import style0 from "./position.vue?vue&type=style&index=0&id=786b6110&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "786b6110",
  null
  
)

export default component.exports